import React, { useEffect, useMemo, useReducer } from 'react';
import { userInfoReducer } from './reducer';
import { UserInfo } from '../models/UserInfo';
import { UserInfoContext } from './useUserInfo';
import { rest } from '../http/rest';

type UserInfoProviderProps = {
  children: React.ReactNode;
};

export const UserInfoProvider = (props: UserInfoProviderProps) => {
  const [state, dispatch] = useReducer(userInfoReducer, null);
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  useEffect(() => {
    const fetchUserInfo = async () => {
      const response = await rest.get<UserInfo>('/user/me');
      const userInfo = response.data as UserInfo;
      const pilotPatients = (userInfo.patients ?? []).filter(
        (patient) => patient.eligibleForPilotProgram,
      );
      const currentProviders = pilotPatients.reduce((map, patient) => {
        map.set(patient.providerSfId, patient.providerName);
        return map;
      }, new Map<string, string>());
      userInfo.currentProviders = currentProviders;
      userInfo.hasPilotEligibleClient = !!currentProviders.size;
      userInfo.pilotPatients = pilotPatients;
      return userInfo;
    };
    fetchUserInfo().then((userInfo) => dispatch({ type: 'INIT', userInfo }));
  }, [dispatch]);

  if (!contextValue.state) {
    return null;
  }
  return (
    <UserInfoContext.Provider
      value={{ state: contextValue.state, dispatch: contextValue.dispatch }}
    >
      {props.children}
    </UserInfoContext.Provider>
  );
};
